import React from 'react';
import DropdownMenu from './DropdownMenu';
import StaffAssignListItem from './StaffAssignListItem';

const getFullName = (staff, userid) => {
  if (userid === staff.id) {
    return staff.firstName + ' ' + staff.lastName + ' (Me)';
  }
  return staff.firstName + ' ' + staff.lastName;
};
const getOtherStaff = (assignedTo, allAssignmentMap) => {
  const assignmentInfo = allAssignmentMap.filter(
    (assignement) => assignement.assigned_to === assignedTo,
  );
  if (
    assignmentInfo &&
    assignmentInfo.length > 0 &&
    assignmentInfo[0].location
  ) {
    return {
      firstName: assignmentInfo[0].location.name,
      id: assignedTo,
      lastName: '',
      business_id: assignmentInfo[0].location.id,
    };
  } else {
    return null;
  }
};
const getLogoName = (staff) => {
  if (staff.lastName) {
    return staff.firstName.charAt(0) + staff.lastName.charAt(0);
  } else {
    return staff.firstName.substring(0, 2);
  }
};
const removeMineAndSortAlphabeltically = (list, selectedStaff) => {
  const clearList = list.filter((staff) => staff.role !== 'MARKETING');
  const others = selectedStaff
    ? clearList.filter((staff) => staff.id !== selectedStaff.id)
    : clearList;
  return others.sort(function (a, b) {
    let nameA = getFullName(a);
    let nameB = getFullName(b);
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
};

const StaffAssignList = ({
  onChange,
  dropdownMenu,
  auth,
  selectedOption,
  assignedTo,
  dropdownType,
  allAssignmentMap,
  ...rest
}) => {
  const selected = dropdownMenu.filter((staff) => staff.id === assignedTo);
  const selectedStaff =
    selected.length > 0
      ? selected[0]
      : assignedTo
        ? getOtherStaff(assignedTo, allAssignmentMap)
        : null;
  const isOtherStaff = selected.length === 0 && assignedTo;
  const { userid } = auth;
  return (
    <DropdownMenu {...rest}>
      {(dropdownType === 1 || dropdownType === 2) && selectedStaff && (
        <>
          <StaffAssignListItem
            label={getFullName(selectedStaff, userid)}
            logoname={getLogoName(selectedStaff)}
            staff={selectedStaff}
            id={selectedStaff.id}
            value={selectedStaff.value}
            assignedTo={assignedTo}
            isOtherStaff={isOtherStaff}
            type="BUTTON"
            className="report_issue"
            iconclassName="fas fa-flag"
            selectedOption={selectedOption}
          />
          <div className="dropdown-menu__title">Transfer to</div>
        </>
      )}
      {selectedStaff ? (
        <StaffAssignListItem
          key={dropdownMenu.length}
          value="NONE"
          assignedTo={assignedTo}
          id={null}
          type="BUTTON"
          onClick={onChange}
          className="report_issue"
          iconclassName="fas fa-flag"
          selectedOption={selectedOption}
        />
      ) : (
        <StaffAssignListItem
          key={dropdownMenu.length}
          value="NONE"
          assignedTo={assignedTo}
          id={null}
          type="BUTTON"
          className="report_issue"
          iconclassName="fas fa-flag"
          selectedOption={selectedOption}
        />
      )}

      <>
        <div className="dropdown-menu__title">Assign To</div>
        {/* eslint react/no-array-index-key: "off" */
          removeMineAndSortAlphabeltically(
            dropdownMenu,
            selectedStaff,
            dropdownType,
          ).map((item, index) => {
            return (
              <StaffAssignListItem
                label={getFullName(item, userid)}
                logoname={getLogoName(item)}
                staff={item}
                id={item.id}
                key={index}
                value={item.value}
                assignedTo={assignedTo}
                onClick={onChange}
                type="BUTTON"
                className="report_issue"
                iconclassName="fas fa-flag"
                selectedOption={selectedOption}
              />
            );
          })}
      </>
    </DropdownMenu>
  );
};

export default StaffAssignList;
